/* eslint-disable array-element-newline */
/* eslint-disable new-cap */
import {LitElement, html} from 'lit';
import noUiSlider from 'nouislider';
import {createRef, ref} from 'lit/directives/ref.js';
import styles from './diamond-preview-carat-slider.component.scss?as=stylesheet';
import previewStyles from './diamond-preview.component.scss?as=stylesheet';
import {DIAMOND_PREVIEW_MIN_CARAT, DIAMOND_PREVIEW_MAX_CARAT} from 'extensions/ring-builder/data/constants';
import {defineCustomElement} from 'extensions/utils';

class DiamondPreviewCaratSlider extends LitElement {

	static get styles () {
		return [styles, previewStyles];
	}

	static get properties () {
		return {
			carat: Number,
			max: Number,
			min: Number
		};
	}

	slider = createRef();

	constructor () {
		super();

		this.min = DIAMOND_PREVIEW_MIN_CARAT;
		this.max = DIAMOND_PREVIEW_MAX_CARAT;
	}

	firstUpdated () {
		noUiSlider.create(
			this.slider?.value,
			this.sliderOptions
		);

		// Bind change event listener
		this.slider?.value?.noUiSlider?.on('update', this.handleChange.bind(this));
	}

	updated () {
		this.slider?.value?.noUiSlider?.updateOptions(this.sliderOptions);
	}

	filterPips (value, type) {
		if (type === 0) {
			return value < 2000 ? -1 : 0;
		}
		return value % 1000 ? 2 : 1;
	}

	get sliderFormat () {
		return {
			from: value => {
				return Number(value).toFixed(2);
			},
			to: value => {
				return value.toFixed(2);
			}
		};
	}

	get sliderOptions () {
		return {
			ariaFormat: this.sliderFormat,
			format: this.sliderFormat,
			pips: {
				filter: this.filterPips,
				format: this.sliderFormat,
				mode: 'steps'
			},
			range: {
				max: parseFloat(this.max) || DIAMOND_PREVIEW_MIN_CARAT,
				min: parseFloat(this.min) || DIAMOND_PREVIEW_MAX_CARAT
			},
			start: [parseFloat(this.carat)],
			step: 0.25
		};
	}

	async handleChange ([low]) {
		await this.updateComplete;

		if (this.carat !== low) {
			this.carat = low;
		}

		this.dispatchEvent(new Event('change'));
	}

	render () {
		return html`
			<div class="diamond-preview">
				<div class="diamond-preview--label">
					<div class="diamond-preview-title">View With Carat Size</div>
					<div class="diamond-preview-selection">${this.carat} Carat</div>
				</div>
				<div class="diamond-carats">
					<div class="diamond-carats-label diamond-carats-min">${this.min} Carat</div>
					<div class="diamond-carats-slider" ${ref(this.slider)}></div>
					<div class="diamond-carats-label diamond-carats-max">${this.max} Carat</div>
				</div>
			</div>
		`;
	}

};

defineCustomElement('rb-diamond-preview-carat-slider', DiamondPreviewCaratSlider);
